<template>
  <p 
    :class="baseTextStyleClasses" 
    class="base-text-style"
  >
    <slot />
  </p>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  variation: {
    type: String,
    default: "normal",
    validator: (value) => [
      "normal",
      "positive",
      "negative",
      "strong",
      "subdued",
      "code",
    ].includes(value),
  },
  mode: {
    type: String,
    default: "light",
    validator: (value) => ["light", "dark"].includes(value),
  },
  isInline: {
    type: Boolean,
    default: false,
  },
});

const baseTextStyleClasses = computed(() => ({
  [`base-text-style--variation-${props.variation}`]: true,
  [`base-text-style--mode-${props.mode}`]: true,
  "base-text-style--is-inline": props.isInline,
}));
</script>

<style lang="scss" scoped>
@import "./base-text-style.scss";
</style>
